<template>
    <b-row v-if="options" align-v="end" align-h="start">
        <b-col md="12">
          <b-row align-v="end">
            <b-col>
            <md-field>
              <label>{{$t('Type to Search')}}</label>
              <md-input v-model="filter" @update="filterChanged" @keypress="pressEnterFilter"></md-input>
            </md-field>
            </b-col>
            <b-col>
            <i style="margin:6px 8px 15px" @click.stop="ClickOnSearchButton" class="primary fa fa-search fa-lg"/>
            <i v-if="options.isExtendSearch" style="margin:6px 8px 15px;" @click.stop="ClickOnExtendedSearchButton" class="primary fa fa-search-plus fa-lg"/>
            <i v-if="options.isRestoredSearcher" style="margin:6px 8px 15px;" @click.stop="ClickOnRestoreSearchButton" class="primary fa fa-times-circle fa-lg"/>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
</template>

<style>

.md-field {
  margin: 6px 8px;
}
</style>

<script>
export default {
  props: {
    options: {
      isShowAddButton: true,
      isShowClearButton: false,
      isShowCheckButton: false,
      isShowVerifyButton: false,
      isCustomers: false,
      isExtendSearch: false,
      isRestoredSearcher: false
    }
  },
  data () {
    return {
      curCustomers: 0,
      filter: '',
      customersOptions: [
        {value: 0, text: this.$i18n.t('Сommon\'s')},
        {value: 1, text: this.$i18n.t('Card\'s')}
      ],
      pageOptions: [20, 40, 60, 80, 100],
      perPage: 20,
      restoreSearch: require('@/assets/img/document_delete.png'),
      addDocumentImage: require('@/assets/img/file_add.png'),
      searchDocumentImage: require('@/assets/img/search.png')
    }
  },
  methods: {
    clearFilter () {
      this.filter = ''
    },
    filterChanged () {
      this.$emit('filterChanged', this.filter)
    },
    paginationChanged () {
      this.$emit('paginationChanged', this.perPage)
    },
    customersChanged () {
      this.$emit('customersChanged', this.curCustomers)
    },
    ClickOnAddButton () {
      this.$emit('ClickOnAddButton')
    },
    ClickOnClearButton () {
      this.$emit('ClickOnClearButton')
    },
    ClickOnCheckButton () {
      this.$emit('ClickOnCheckButton')
    },
    ClickOnVerifyButton () {
      this.$emit('ClickOnVerifyButton')
    },
    ClickOnSearchButton () {
      this.$emit('filterChanged', this.filter)
      this.$emit('ClickOnSearchButton')
    },
    pressEnterFilter (event) {
      if (event.keyCode === 13) {
        this.$emit('filterChanged', this.filter)
        this.$emit('ClickOnSearchButton')
      }
    },
    ClickOnExtendedSearchButton () {
      this.$emit('ClickOnExtendedSearchButton')
    },
    ClickOnRestoreSearchButton () {
      this.$emit('ClickOnRestoreSearchButton')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/TableManagerSearch.vue